import { useEffect, useState } from 'react';
import { api } from './api.js';

// The public holidays of `userId`'s own country between `from` and `to` (ISO
// dates) as a Map of date → name, so a calendar can grey them out like a
// weekend. The country is the person's, not the viewer's: a manager looking
// at a Slovak member sees Slovak holidays. Empty while loading or when the
// request fails — the calendar then marks weekends only.
export function useHolidays(userId, from, to) {
  const [holidays, setHolidays] = useState(() => new Map());
  useEffect(() => {
    if (!userId) return undefined;
    let active = true;
    api(`/users/${userId}/holidays?from=${from}&to=${to}`)
      .then((result) => {
        if (active)
          setHolidays(
            new Map(result.holidays.map(({ date, name }) => [date, name])),
          );
      })
      .catch(() => {
        if (active) setHolidays(new Map());
      });
    return () => {
      active = false;
    };
  }, [userId, from, to]);
  return holidays;
}
